<template>
    <div>
        <ReactiveModal
            id="task-modal"
            class="modal_plan-task plan-task"
            :title="this.task.name"
            :class="{'iframe-view': iframeView }"
            modal-size="custom"
            v-on:close="$emit('close')">
            <template v-if="hideHeaderBtn" v-slot:left-actions>
              <div></div>
            </template>
            <template v-else v-slot:left-actions>
                <div>
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Закрыть</button>
                    <button type="button" class="btn btn-primary" @click="$emit('openTasks')">Все задачи</button>
                </div>
            </template>

            <template v-slot:actions>
                <div class="d-flex justify-content-between">
                    <button v-if="isAccessAllow" class="btn btn-primary mr-auto" @click="confirmContext = true">Удалить</button>
                    <button v-if="hideHeaderBtn" type="button" class="btn btn-primary ml-auto" @click="$emit('openTasks')">Все задачи</button>
                </div>
            </template>

            <div class="task" v-if="task.id">
                <div class="task__row task-summary">
                    <div class="task__col">
                        <h3 class="task-summary__title">
                            <span class="text-icon" v-if="!openEditName">
                                {{ task.name }}
                                <Icon v-if="isAccessAllow" id="edit" @click="openEditName = true"></Icon>
                            </span>
                            <EditText
                                v-else
                                v-model.trim="editableTask.name"
                                v-on:apply="openEditName = false;updateTask()"
                                v-on:cancel="openEditName = false;editableTask.set('name', task.name)"
                            />
                        </h3>

                        <div class="task-prop">
                            <strong>URL:</strong>
                            <a :href="task.url" target="_blank" class="task-prop__value ellipsis">{{ task.url }}</a>
                        </div>

                        <div class="task-prop">
                            <strong>Домен:</strong>
                            <div class="task-prop__value ellipsis">{{ task.domain }}</div>
                        </div>

                        <div class="task-prop">
                            <strong>Мониторинг:</strong>
                            <div class="task-prop__value">{{ runLabel }}</div>
                        </div>

                        <div class="task-prop">
                            <strong>Постановщик задачи:</strong>
                            <div class="task-prop__value">{{ ownerMyser.lastname }} {{ ownerMyser.firstname }}</div>
                        </div>
                    </div>
                    <div class="task__col">
                        <h3 class="task-summary__title"></h3>

                        <PlanPropDate
                            class="task-prop_date-start"
                            label="Старт:"
                            :value="task.dateStart"
                            @update="v => editableTask.set('dateStart', v) && updateTask(true)"
                        />

                        <PlanPropDate
                            class="task-prop_date-finish"
                            label="Финиш:"
                            :value="task.datePlanFinish"
                            :disabled="'2' !== task.status"
                            @update="v => editableTask.set('datePlanFinish', v) && updateTask(true)"
                        />

                        <Status
                            v-if="isAccessAllow"
                            :list="taskStatuses"
                            :active="task.status"
                            @update="v => editableTask.set('status', v) && updateTask(true)"
                        />
                        <div v-else class="task-prop task-prop_status">
                          <strong class="mr-2">Статус: </strong>{{taskStatuses.find(s => +s.id === +task.status)?.name || 'не выбран'}}
                        </div>
                    </div>
                    <div class="task__col">
                        <h3 class="task-summary__title"></h3>

                        <Priority
                            :disable="!isAccessAllow"
                            :value="task.priority"
                            @update="v => editableTask.set('priority', v) && updateTask()"
                        />
                        <Tags
                            :disabled="!isAccessAllow"
                            :tags-only="!isAccessAllow"
                            :tags="task.tags"
                            @update="v => editableTask.set('tags', v) && updateTask()"
                        />
                    </div>
                    <div class="task__col">
                        <h3 class="task-summary__title">Журнал изменений</h3>

                        <TaskLogs :urlTaskId="urlTaskId"/>
                    </div>
                </div>
                <div class="task-detail">
                    <h3 class="task-summary__title">Список подзадач</h3>

                    <div class="task-detail__row">
                        <Subtasks
                            class="task-detail__streams"
                            :is-access-allow="isAccessAllow"
                            :urlTaskId="urlTaskId"
                            :service="service"
                            :runId="runId"
                            :urlId="urlId"
                        />

                        <template v-if="selectedStream && Object.keys(selectedStream).length">
                            <Subtask :is-access-allow="isAccessAllow" class="task-detail__stream"/>
                            <StreamComments :is-access-allow="isAccessAllow" class="task-detail__comments"/>
                        </template>
                    </div>
                </div>
            </div>
        </ReactiveModal>

        <ReactiveConfirm
            v-if="confirmContext"
            @close="confirmContext = false"
            @confirm="deleteTask"
            title="Подтверждение действия"
            confirmText="Удалить">
            <p>Действительно удалить?</p>
        </ReactiveConfirm>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Priority from "@/vue/plan/input/Priority";
import Tags from "@/vue/plan/input/Tags";
import Status from "@/vue/plan/input/Status";
import TaskLogs from "@/vue/plan/input/TaskLogs";
import EditText from "@common/vue/components/form/EditText";
import StreamComments from "@/vue/plan/url/Task/StreamComments";
import Subtask from "@/vue/plan/url/Task/Subtask";
import Subtasks from "@/vue/plan/url/Task/Subtasks";
import {dateToLeadingZeroObject} from "@common/utils/date";
import PlanPropDate from "@/vue/plan/input/PlanPropDate";

export default {
    name: "PlanUrlTaskModal",
    components: {
        PlanPropDate,
        Subtasks,
        Subtask,
        StreamComments,
        EditText,
        TaskLogs,
        Status,
        Tags,
        Priority,
    },
    props: ['hideHeaderBtn', 'isAccessAllow', 'urlTaskId', 'service', 'runId', 'urlId', 'iframeView'],
    data() {
        return {
            openEditName: false,
            confirmContext: false,
        }
    },
    computed: {
        ...mapState({
            users: state => state.planUrlTask.users,
            // @var PlanTaskModel. Fetched by `fetchPlanUrlTask`.
            task: state => state.planUrlTask.task,
            // Fetched by `fetchPlanUrlTask`.
            taskStatuses: state => state.planUrlTask.taskStatuses,
            // Fetched by `fetchPlanUrlTaskStreamList`
            taskStreamList: state => state.planUrl.taskStreamList,
            selectedStream: state => state.planUrl.selectedStream,
            streamId: state => state.planCRUD.streamId,
        }),
        editableTask() {
            // Copy of original, for temporary editing view.
            return this.task;
        },
        runLabel() {
            if (this.task.runDateStart) {
                const {days, months, years, hours, minutes, seconds} = dateToLeadingZeroObject(this.task.runDateStart);
                return `${days}.${months}.${years} ${hours}:${minutes}:${seconds}`;
            }

            return '';
        },
        myser() {
            return this.users.find(u => u.id === String(this.task.myserId)) || {};
        },
        ownerMyser() {
            return this.users.find(u => u.id === String(this.task.ownerMyserId)) || {};
        },
    },
    watch: {
        'selectedStream.id': function (id) {
            if (id && id !== this.streamId) {
                Vue.set(this.$store.state.planCRUD, 'streamId', id);
            }
        },
    },
    mounted() {
        this.$store.dispatch('fetchPlanUrlTask', {
          taskId: this.urlTaskId,
          service: this.service,
          runId: this.runId,
          urlId: this.urlId,
        });

        this.$store.dispatch('fetchPlanUrlUsers');
        // this.$store.dispatch('fetchPlanUrlData');
    },
    methods: {
        updateTask(fetchStages = false) {
            this.editableTask.update(this.$store)
                .catch(e => {
                    if (400 === e.response.status || 400 === e.response.data?.status) {
                        if (e.response.data?.message) {
                            return this.$emit('requestError', e.response.data.message);
                        }
                    }

                    this.$emit('requestError', 'При обновлении задачи произошла ошибка.');
                })
                .finally(e => {
                    if (fetchStages) {
                        this.$store.dispatch('fetchPlanStream', {
                          streamId: this.selectedStream.id,
                          service: this.service,
                          runId: this.runId,
                          urlId: this.urlId,
                        });
                    }

                    this.$store.dispatch('syncNewLogs', {task: {id: this.urlTaskId}});
                });
        },
        deleteTask() {
          this.$store.dispatch('deletePlanUrlTask', {task: this.task, runId: this.runId, service: this.service, urlId: this.urlId})
              .then(r => {
                window.location.reload();
              })
              .catch(e => {
                if (400 === e.response.status || 400 === e.response.data?.status) {
                  if (e.response.data?.message) {
                    return this.$emit('requestError', e.response.data.message);
                  }
                }

                this.$emit('requestError', 'При удалении задачи произошла ошибка.');
              });
        },
    }
}
</script>

<style lang="scss">
@import "/resources/common/scss/abstracts/abstracts";

@import "/resources/scss/modules/task/task-summary";
@import "/resources/scss/modules/task/task-prop";

#task-modal {
    & .modal-dialog {
        min-width: 1500px;
        max-width: 1730px;
    }

    &:not(.iframe-view) .modal-dialog {
        width: calc(100% - 30px);
    }

    &.iframe-view .modal-dialog {
        width: 100%;
    }

    & .modal-body {
        min-width: 1320px;
    }
}

.task-detail {
    &__row {
      display: grid;
      grid-template-columns: minmax(12%, 220px) 1fr minmax(250px, 300px);
      column-gap: 20px;
    }

    &__streams {
        width: 100%;
        border-right: 1px solid #30B68F;
    }

    &__stream {
        flex: 1;
        min-width: 910px;
        width: 100%;
    }

    &__comments {
        width: 100%;
    }
}

.task-summary {
    width: 100%;

    .tags {
        display: flex;
        flex-wrap: wrap;

        .tag {
            max-width: 80px;
            margin-right: 2.5px;
            margin-bottom: 2.5px;
            padding: 4px;
            border-radius: 10px;
            background: #DADAEA;
            font-size: 10px;
            line-height: 1.2;
            color: #A6ABBD;

            .icon {
                color: inherit;
                flex: 0 0 var(--size);
            }
        }
    }
}

@media screen and (max-width: 1600px) {
    .modal .stage-list thead {
        font-size: 15px;
    }
}

.plan-task .task-summary {
    .task-prop_date-start,
    .task-prop_date-finish {
        display: none;
    }

    .task-prop_date-start,
    .task-prop_date-finish,
    .task-prop_status {
        margin-bottom: 16px;
    }
}
</style>
